import { render, staticRenderFns } from "./PricingTableDescriptionBlock.vue?vue&type=template&id=04c87a45&"
import script from "./PricingTableDescriptionBlock.vue?vue&type=script&lang=js&"
export * from "./PricingTableDescriptionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports